import type {
  AuditEvent,
  Device,
  DeviceUseStatement,
  Extension,
  Patient,
  Reference,
} from 'fhir/r4';

import type { MixedBundle, WithId } from '../types';
import { ExtensionUrl } from './extension';
import { createReference } from './id';
import type { CreateReference } from './reference';

export type CreatePatientBundleOptions = Patient | DeviceUseStatement | Device;
export type CreatePatientBundle = MixedBundle<CreatePatientBundleOptions>;
export type UpdatePatientAuditBundle = MixedBundle<Patient | AuditEvent>;

export type Risk = 'high' | 'medium' | 'low';

export const getRisk = (patient: Patient): Risk | undefined => {
  const risk = patient.extension?.find(
    (e) => e.url === ExtensionUrl.riskClassification && e.valueCode,
  );

  return risk ? (risk.valueCode as Risk) : undefined;
};

export const createRiskExtension = (risk: Risk): Extension => ({
  url: ExtensionUrl.riskClassification,
  valueCode: risk,
});

export const getPatientNameDisplay = (patient: Patient): string | undefined => {
  const names = patient.name;

  const name = names?.find((n) => n.text);

  return name?.text;
};

/**
 * @deprecated use `createPatientRefWithId` for more correct ID and type handling
 */
export const createPatientRef = (patient: Patient): Reference => {
  const name = getPatientNameDisplay(patient);

  const id = patient.id || '';

  const ref = createReference('Patient', id, name);

  return ref;
};

export const createPatientRefWithId = (
  patient: WithId<Patient>,
): CreateReference => {
  const name = getPatientNameDisplay(patient);

  const id = patient.id;

  const ref = createReference('Patient', id, name);

  return ref;
};
